import type { TopicExampleRow } from "@nexus/contracts";
import { formatMetricValue } from "@/features/dashboard/lib/format";

const EMPTY_METRIC = "—";

/** Display label for the Examples preview panel title. */
export function topicExamplePreviewTitle(row: TopicExampleRow): string {
  return row.adName;
}

/** Subtitle parts: segment example label, object type, dates. */
export function topicExamplePreviewSubtitle(row: TopicExampleRow): string {
  const parts: string[] = [];
  if (row.example && row.example !== "All") {
    parts.push(row.example);
  }
  if (row.objectType) {
    parts.push(row.objectType);
  }
  if (row.datesActive) {
    parts.push(row.datesActive);
  }
  return parts.join(" · ");
}

/** Abbreviate ≥1K / ≥1M (e.g. $47.4K, 1.2M); keep 2 decimals below 1000. */
function formatTopicExampleNumber(value: number, currencySymbol?: string): string {
  if (currencySymbol !== undefined) {
    return formatMetricValue(value, "currency", currencySymbol);
  }
  if (Math.abs(value) >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(1)}M`;
  }
  if (Math.abs(value) >= 1_000) {
    return `${(value / 1_000).toFixed(1)}K`;
  }
  return value.toFixed(2);
}

export function formatTopicExampleSpend(row: TopicExampleRow, currencySymbol: string): string {
  return formatTopicExampleNumber(row.spend, currencySymbol);
}

export function formatTopicExampleCpa(row: TopicExampleRow, currencySymbol: string): string {
  if (row.cpa === null) return EMPTY_METRIC;
  return formatTopicExampleNumber(row.cpa, currencySymbol);
}

export function formatTopicExampleRoas(row: TopicExampleRow): string {
  if (row.roas === null) return EMPTY_METRIC;
  return formatTopicExampleNumber(row.roas);
}
